import script from "./Step1.vue?vue&type=script&setup=true&lang=js"
export * from "./Step1.vue?vue&type=script&setup=true&lang=js"

import "./Step1.vue?vue&type=style&index=0&id=24ec5aff&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24ec5aff"]])

export default __exports__